import { Col, Container, Row, Navbar} from 'react-bootstrap';
import React,{useState} from 'react';
import ReactPlayer from 'react-player/lazy';
import UserWayAccessibilityMenu from "./UserWayAccessibilityMenu";
import HTMLReactParser from 'html-react-parser';

export default function Header({pavanLink}) {
  const [navbar, setNavbar] = useState(false);

  const changebackground = () => {
    if(window.scrollY >= 9){
      setNavbar(true);
    }else{
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changebackground);

  return (
    <Container fluid id="header-wrapper ">
      <Row>
        <Col>
      <Navbar
          collapseOnSelect
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? 'navbar active' : 'navbar' }
        >
          <Navbar.Brand>
            <a href="https://www.swmc.com/">
              <img
                src={`${process.env.REACT_APP_CDN_LINK}/swmc-images/sunwest-trust-white-logo.png`}
                className="img-fluid w-50 main_logo"
                alt="Sun West Mortgage Logo"
              />
            </a>
          </Navbar.Brand>
          <div className="userway-div">
          <UserWayAccessibilityMenu color="white"  />
          </div>
        </Navbar>
        </Col>
        </Row>
      <Row className="header-d">
        <Col lg={1} xl={1} className="ml-auto"></Col>
        <Col md={12} lg={5} xl={5} className="mt-5 mb-3">
          <div className="pt-3 mb-3 pageInfoHighlightsContainer">
            <h4 className="pageInfoHeading d-none d-lg-block d-xl-block">
              An Insightful Chat Session <br /> of {HTMLReactParser(pavanLink)} With <br /> Aaron Amuchastegui on <br /> Real Estate Rockstars Radio
            </h4>

            <h4 className="pageInfoHeading2 d-lg-none d-xl-none d-sm-block d-xs-block text-center">
              An Insightful Chat Session of {HTMLReactParser(pavanLink)} With Aaron Amuchastegui on Real Estate Rockstars Radio
            </h4>
          </div>
        </Col>
        <Col md={12} lg={4} xl={4} style={{ marginTop: "", zIndex: "3" }}>
          <div id="main-player" className="player-wrapper">
            <ReactPlayer
              className="react-player"
              url="https://www.youtube.com/watch?v=dVSAu95yDfY"
              width="115%" height="130%"
              light={`${process.env.REACT_APP_ROCKSTARS_CDN_IMAGES}thumbnail-plaly.webp`}
              playing con controls
            />
          </div>

        </Col>

        <Row className="row2" style={{ marginTop: "-9rem", zIndex: "2" }}>
          <Col lg={2} xl={2} sm={0} xs={0} className="cl-1 ml-auto d-lg-block d-xl-block"></Col>

          <Col md={6} sm={4} xs={4} lg={2} className="mx-lg-3 mx-xl-3 mt-3" >

          </Col>
        </Row>
      </Row>
    </Container>
  );
}
